@if (this.resolutionOptions$ | async; as options) {
  <pm-form-field label="RESULT.SIDEBAR.RESOLUTION.TITLE">
    <pm-form-input-select
      [data]="options"
      [clearable]="false"
      [ngModel]="(currentResolution$ | async)?.value"
      (ngModelChange)="onSetResolution($event)"
    />
  </pm-form-field>
}
